export const NOTIFICATIONS_URL_SEARCH_PARAM = 'notifications';
